<template>
    <field-template :required="required" :errors="errors" :name="name" :label="label">
        <template v-slot:field>
            <v-select
                :multiple="multiple"
                :value="modelValue"
                @option:selected="handleInput"
                @option:deselected="handleInput"
                :options="options"
                :label="optionLabel"
                :reduce="transform"
                v-model="content"
            />

            <input v-if="content && content[optionValue]" type="hidden" :name="name" :value="content[optionValue]" />
        </template>
    </field-template>

</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
    name: 'VSelectField',

    emits: ['update:modelValue'],

    components: { vSelect },

    props: {
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        required: {
            type: Boolean
        },
        errors: {
            type: Array
        },
        modelValue: {
            default: '',
        },
        options: {
            type: Array,
            required: true
        },
        optionLabel: {
            type: String,
            default: 'label'
        },
        optionValue: {
            type: String,
            default: 'value'
        },
        transform: {
            type: Function,
            default: o => o
        },
        multiple: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            content: this.modelValue,
        }
    },

    methods: {
        handleInput() {
            this.$emit('update:modelValue', this.content);
            this.$emit('input', this.content)
        }
    }
}
</script>
